<template>
  <v-app id="inspire">
    <v-navigation-drawer v-if="haveNavigation" v-model="drawer" app>
      <v-list dense>
        <v-list-tile
          value="true"
          v-for="(item, i) in itemsNav"
          :key="i"
          :to="item.to"
          @click="drawer = false"
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar v-if="haveToolbar" :color="colorType" dark fixed app>
      <v-toolbar-side-icon
        v-if="haveNavigation"
        @click.stop="drawer = !drawer"
      ></v-toolbar-side-icon>
      <v-toolbar-title>
        <v-btn flat large :ripple="false" :to="{ name: 'Home' }">
          <v-img
            :src="marca"
            alt="Logo Radiodent"
            height="40"
            width="180"
            contain
          ></v-img>
        </v-btn>
        <v-snackbar v-model="tradeDCM" :timeout="0" :color="colorDCM" right top>
          <!-- :timeout="3600000" -->
          <v-scroll-x-transition>
            <v-progress-circular
              v-if="this.loadDCM"
              indeterminate
              color="white"
            ></v-progress-circular>
            <v-icon v-else color="white">
              check
            </v-icon>
          </v-scroll-x-transition>

          <v-scroll-x-transition> </v-scroll-x-transition>
          {{ textDCM }}
        </v-snackbar>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
      >
        <v-btn
          slot="activator"
          color="primary"
          fab
          :small="$vuetify.breakpoint.smAndDown"
        >
          <v-avatar>
            <span class="white--text headline">{{ inicial }}</span>
          </v-avatar>
        </v-btn>

        <v-card>
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ fullname }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  logged_user.email
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-divider></v-divider>

          <v-list dense v-if="logged_user.id_perfil == 4">
            <v-list-tile @click="dialogPwd = true" class="btn-hover-orange">
              <v-list-tile-title>Cambiar contraseña</v-list-tile-title>
            </v-list-tile>

            <!-- <v-list-tile>
              <v-list-tile-title>Editar perfil</v-list-tile-title>
            </v-list-tile> -->
          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn flat @click="exit" color="primary">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer v-if="isLogged" color="secondary" app>
      <span class="white--text">Radiodent &copy; 2019</span>
    </v-footer>
    <v-dialog v-model="dialogPwd" persistent max-width="600px">
      <v-form
        ref="formPwd"
        class="px-4 login"
        v-model="valid"
        v-on:submit.prevent="submitPwd"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="headline">Cambio de contraseña</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md6>
                  <v-text-field
                    label="Nueva contraseña*"
                    prepend-icon="lock"
                    name="password"
                    type="password"
                    v-model="password"
                    :rules="passwordRules"
                    required
                    autofocus
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-text-field
                    label="Repita Nueva contraseña*"
                    prepend-icon="lock"
                    name="password_confirmation"
                    type="password"
                    v-model="password_confirmation"
                    :rules="password_confirmation_rules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <small>* campos requeridos</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeDialog"
              >Cancelar</v-btn
            >
            <!-- <v-btn color="blue darken-1" flat @click="dialogPwd = false"
              >Save</v-btn
            > -->
            <v-btn
              class="mx-0 my-4 px-5 enter subheading"
              :disabled="ready"
              type="submit"
              >Restaurar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar v-model="snackbar" :bottom="true" :multi-line="true">
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
// import CoreComponent from './components/CoreComponent.vue'
import axios from "axios";
import { bus } from "./main";
export default {
  name: "app",
  /*components: {
    CoreComponent
  },*/
  created() {
    this.$forceUpdate();
    localStorage.uploadingDCM = false;
    // console.log('localStorage.uploadingDCM', localStorage.uploadingDCM)
    bus.$on("tradeDCM", (obj) => {
      this.colorDCM = obj.color;
      if (obj.status == "start") {
        localStorage.uploadingDCM = true;
        this.loadDCM = true;
        this.tradeDCM = true;
        this.textDCM = obj.text;
      } else {
        this.loadDCM = false;
        localStorage.uploadingDCM = false;
        this.textDCM = obj.text;
        setTimeout(() => {
          this.tradeDCM = false;
        }, 3000);
      }
    });
    bus.$on("userStatus", (obj) => {
      // localStorage.isLogged = obj.isLogged
      // console.log('this.logged_user', JSON.parse(JSON.stringify(obj)))
      localStorage.setItem("isLogged", JSON.stringify(obj.isLogged));
      this.isLogged = obj.isLogged;
      if (obj.isLogged) {
        if (this.isPatient(obj)) {
          let nameParts = obj.logged_user.fullname.split(" ");
          obj.logged_user.apellidos = nameParts.slice(0, 2).join(" ");
          obj.logged_user.nombres = nameParts[2];
        }
        // console.log('LOGGED router Inicio')
        this.logged_user = obj.logged_user;
        localStorage.setItem("logged_user", JSON.stringify(obj.logged_user));
        let itemsNav = [];

        /**
         * ROLES
         * 1: Administrador
         * 2: Tecnólogo
         * 3: Dentista
         * 4: Solicitante
         * 5: Paciente
         * 6: Personal
         */

        if (this.logged_user.id_perfil == 4 || this.isPatient()) {
          // itemsNav.push( { icon: "find_in_page", title: "Consultar", to: { name: "Find" } } )
          this.$router.push({ name: "Find" });
          // this.$router.push({ name: "Home" });
          return;
        } else {
          itemsNav.push({
            icon: "assignment_ind",
            title: "Exámenes",
            to: { name: "Home" },
          });
        }

        if (this.logged_user.id_perfil < 4 || this.logged_user.id_perfil == 6) {
          itemsNav.push({
            icon: "people",
            title: "Pacientes",
            to: { name: "Patients" },
          });
          itemsNav.push({
            icon: "description",
            title: "Plantillas",
            to: { name: "Templates" },
          });
        }

        if (
          this.logged_user.id_perfil == 1 ||
          this.logged_user.id_perfil == 2 ||
          this.logged_user.id_perfil == 6
        ) {
          itemsNav.push({
            icon: "local_hospital",
            title: "Odontólogos",
            to: { name: "Applicants" },
          });
          itemsNav.push({
            icon: "location_city",
            title: "Instituciones",
            to: { name: "Institutions" },
          });
          itemsNav.push({
            icon: "dns",
            title: "Modalidades",
            to: { name: "Modalities" },
          });
          itemsNav.push({
            icon: "check_box",
            title: "Prestaciones",
            to: { name: "Provisions" },
          });
          itemsNav.push({
            icon: "supervised_user_circle",
            title: "Usuarios",
            to: { name: "Users" },
          });
        }

        localStorage.setItem("itemsNav", JSON.stringify(itemsNav));
        this.itemsNav = itemsNav;

        this.$router.push({ name: "Exams" });
      } else {
        // console.log('LOGOUT router Login')
        this.logged_user = null;
        localStorage.removeItem("isLogged");
        localStorage.removeItem("logged_user");
        localStorage.removeItem("itemsNav");
        this.$router.push({ name: "Login", query: { message: obj.message } });
      }
    });
    if (JSON.parse(localStorage.getItem("isLogged")) !== true) {
      bus.$emit("userStatus", { isLogged: false });
    } else {
      this.logged_user = JSON.parse(localStorage.getItem("logged_user"));
      // console.log(
      //   "this.logged_user",
      //   JSON.parse(JSON.stringify(this.logged_user))
      // );
      if (!this.logged_user.id_perfil) {
        bus.$emit("userStatus", { isLogged: false });
      }

      if (this.logged_user) {
        [
          this.logged_user.apellido_paterno,
          this.logged_user.apellido_materno,
        ] = this.logged_user.apellidos.split(" ");
        this.itemsNav = JSON.parse(localStorage.getItem("itemsNav"));
        // console.log("this.itemsNav", this.itemsNav);
      }
    }
  },
  data: () => ({
    drawer: false,
    marca: "/img/logo-radiodent.png",
    logged_user: null,
    itemsNav: [],
    isLogged: true,
    menu: false,
    tradeDCM: false,
    colorDCM: "",
    textDCM: "",
    loadDCM: true,
    dialogPwd: false,
    snackbar: false,
    snackbarText: null,
    password: null,
    password_confirmation: null,
    passwordRules: [
      (v) => !!v || "Password es requerido",
      (v) => (v && v.length >= 6) || "Password mínimo de 6 caracteres",
      // v => v === this.editedItem.repassword || "Ambos password deben ser iguales"
    ],
    valid: false,
  }),
  computed: {
    /* isLogged: () => {
        return JSON.parse(localStorage.getItem('isLogged'))
      }, */
    colorType: function() {
      return this.isPatient() ? "primary" : "accent";
    },
    inicial: function() {
      return this.logged_user
        ? this.logged_user.nombres.charAt(0).toUpperCase() +
            this.logged_user.apellido_paterno.charAt(0).toUpperCase()
        : "";
    },
    fullname: function() {
      return this.logged_user
        ? this.logged_user.nombres + " " + this.logged_user.apellidos
        : /*
            this.logged_user.apellido_paterno +
            " " +
            this.logged_user.apellido_materno
            */
          "";
    },
    haveNavigation() {
      return (
        this.isLogged &&
        (this.logged_user.id_perfil < 4 || this.logged_user.id_perfil == 6) &&
        this.$route.name != "Images" &&
        this.$route.name != "NewImages"
      );
    },
    haveToolbar() {
      return (
        this.isLogged &&
        this.$route.name != "Images" &&
        this.$route.name != "NewImages"
      );
    },
    password_confirmation_rules() {
      return [
        (v) => !!v || "Password es requerido",
        // (v) => (v && v.length >= 6) || "Password mínimo de 6 caracteres",
        (v) => v === this.password || "Ambos password deben ser iguales",
      ];
    },
    ready() {
      return this.password && this.password_confirmation && this.valid
        ? false
        : true;
    },
  },
  methods: {
    goTo: function(name, params = {}) {
      this.$router.push({
        name: name,
        params: params,
      });
    },
    exit: function() {
      bus.$emit("userStatus", {
        isLogged: false,
        message: "Sesión de usuario cerrada",
      });
    },
    isPatient: function(user = this) {
      // return this.logged_user.id_perfil == 5
      return user.logged_user.type == "paciente";
    },
    closeDialog: function() {
      this.password = null;
      this.password_confirmation = null;
      this.dialogPwd = false;
    },
    submitPwd: function() {
      if (this.$refs.formPwd.validate()) {
        var that = this;
        // console.log("SEnd form");
        /* DEBUG */
        var debug = false;

        const setSession = axios.create({
          timeout: 10000,
          withCredentials: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "x-www-form-urlencoded",
          },
          params: {
            accion: "cambioClaveSolicitante",
            api_token: this.logged_user.api_token,
            password: this.password,
          },
        });
        // console.log("setSession", setSession);

        setSession
          .post(window.base_path + window.ws)
          .then((result) => {
            // console.log(result, result.data.response, result.data.callback);
            if (debug) {
              // result.data.response = true;
              // result.data.callback = fakeuser;
            }

            if (result.data.response) {
              that.snackbarText = result.data.message;
              that.snackbar = true;
              that.closeDialog();
            } else {
              that.snackbarText = result.data.message;
              that.snackbar = true;
            }
          })
          .catch((error) => {
            if (error.response) {
              that.snackbarText =
                "Algo anda mal! (cod: " + error.response.status + ").";
            } else if (error.request) {
              that.snackbarText = "Algo anda mal con la validación.";
            } else {
              that.snackbarText = "Algo anda mal con el sistema.";
            }
            that.snackbar = true;
          });
      } else {
        // console.log('No valido')
      }
    },
    debug: function() {
      this.colorDCM = this.debugColors[this.i];
      this.textDCM = "Debug SB";
      this.loadDCM = !this.loadDCM;

      if (this.loadDCM == false) {
        this.i = this.i == 2 ? 0 : this.i + 1;
        setTimeout(() => {
          this.tradeDCM = !this.tradeDCM;
          //this.loadDCM = !this.loadDCM
        }, 2000);
      } else {
        this.tradeDCM = !this.tradeDCM;
      }
    },
  },
  watch: {
    logged_user: function() {
      if (this.logged_user) {
        [
          this.logged_user.apellido_paterno,
          this.logged_user.apellido_materno,
        ] = this.logged_user.apellidos.split(" ");
      }
    },
    password_confirmation: function() {
      if (this.password_confirmation != this.password) {
        // console.log("not mach");
      } else {
        // console.log("mach");
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.btn-hover-orange {
  color: #f57e57;
  :hover {
    color: #ff1c03;
  }
}
</style>
